import { FunctionComponent } from "react";
import Drafts from "@Components/organisms/Drafts";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import WithGlobalLoader from "@Components/WithGlobalLoader";

const DraftsPage: FunctionComponent = () => {
  return (
    <WithGlobalLoader initialLoading={true}>
      <Header />
      <Drafts />
      <Footer />
    </WithGlobalLoader>
  );
};

export default DraftsPage;
